import { Component } from "@angular/core";

@Component({
	selector: "app-main",
	templateUrl: "./main.component.html",
	styleUrl: "./main.component.css",
	standalone: false
})
export class MainComponent { }